import { render, staticRenderFns } from "./CardsProductsIman.vue?vue&type=template&id=70965860&scoped=true&"
import script from "./CardsProductsIman.vue?vue&type=script&lang=js&"
export * from "./CardsProductsIman.vue?vue&type=script&lang=js&"
import style0 from "./CardsProductsIman.vue?vue&type=style&index=0&id=70965860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70965860",
  null
  
)

export default component.exports